import DefaultModal from '../defaultModal/DefaultModal';
import useTranslation from '../../../../hooks/translation/useTranslation';
import DefaultButton from '../../buttons/defaultButton/DefaultButton';
import { deactivateAccountService } from '../../../../../services/customer/profileServices';
import { useAuth } from '../../../../contexts/userContext/userContext';
import { useModal } from '../../../../contexts/modalsContext/modalsContext';

function AccountDeactivateModal() {
  const { resetUser } = useAuth();
  const { trans } = useTranslation();
  const { showDeactivateModal, setShowDeactivateModal } = useModal();

  const handleClose = () => {
    setShowDeactivateModal(false);
  };

  const handleConfirm = async () => {
    await deactivateAccountService();
    resetUser();
    handleClose();
  };
  return (
    <DefaultModal
      show={showDeactivateModal}
      setShow={handleClose}
      className="ticket-refund-modal"
    >
      <div className="flex flex-col gap-5">
        <h3 className="text-center">
          {trans('deactivate_account_question')}
        </h3>
        <div className="flex justify-between items-center">
          <DefaultButton className="!bg-gray-gr py-3" onClick={handleClose}>
            {trans('reject')}
          </DefaultButton>
          <DefaultButton
            className="py-3"
            onClick={handleConfirm}
          >
            {trans('confirm')}
          </DefaultButton>
        </div>
      </div>
    </DefaultModal>
  );
}

export default AccountDeactivateModal;
